import { FC } from 'react';
import { useGetUser } from '@/queries/user';
import { Skeleton, Text } from '@mofid-securities/uikit';

interface ICompleteRegisterDescription {
  message: string;
  shouldShowMessage: boolean;
}

export const CompleteRegisterDescription: FC<ICompleteRegisterDescription> = ({
  message,
  shouldShowMessage,
}) => {
  const { data, isLoading } = useGetUser();

  if (isLoading) {
    return (
      <div className="flex flex-col">
        <Skeleton height={23} />
        <div className="mt-2 flex flex-col gap-y-1">
          <Skeleton height={19} />
          <Skeleton height={19} />
          <Skeleton className="sm:hidden" height={19} width={150} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-2">
      <Text color="blue-DEFAULT" size="sm" weight={600}>
        تکمیل افتتاح حساب در کارگزاری مفید
      </Text>
      <Text color="gray-100" size="sm" weight={400}>
        {shouldShowMessage ? (
          message
        ) : (
          <>
            {data?.displayName ? data.displayName : 'کاربر گرامی'}، شما ثبت نام
            اولیه را در کارگزاری مفید انجام داده‌اید. جهت استفاده بهتر از تمامی
            خدمات برنامه، ابتدا ثبت‌نام خود را تکمیل نمایید.
          </>
        )}
      </Text>
    </div>
  );
};
